export enum ExecutionType {
  Unknown = 0,
  DUE_DATE = 1,
  IMMEDIATE = 2,
  ONE_WEEK_BEFORE_DUE_DATE = 3,
}
